export const socialUrls = {
  facebookUrl: 'https://www.facebook.com/HousingAnywherecom',
  twitterUrl: 'https://twitter.com/HousingAnywhere',
  linkedinUrl: 'https://linkedin.com/company/housinganywhere-com',
  youtubeUrl: 'https://www.youtube.com/user/HousingAnywhere',
};
